/* eslint-disable max-len */
import { Entity, SystemInterface } from '@goodboydigital/odie';

import { Game } from '../Game';

export class CheckpointSystem implements SystemInterface
{
    public game: Game;
    public checkPoint: {x: number, y: number};
    private waitingForLanding = false;

    constructor(entity: Entity)
    {
        this.game = entity.scene as Game;
        this.checkPoint = { x: 0, y: 0 };
        this.game.onIdle.connect(() => this.onGameIdle());
        this.game.onPlay.connect(() => this.onGamePlay());
        this.game.race.onRaceStart.connect(() => this.onRaceStart());
        this.game.race.onRaceFinish.connect(() => this.onRaceFinish());
        this.game.physics.physicsFixedUpdateRunner.add(this as any);
    }

    private onGameIdle(): void
    {
        this.resetCheckpoint({ x: 600, y: -100 });
    }

    private onGamePlay(): void
    {
        this.resetCheckpoint({ x: this.game.level.courseStartX - 500, y: -200 });
    }

    private onRaceStart(): void
    {
        this.resetCheckpoint({ x: this.game.level.courseStartX, y: this.game.level.courseStartY });
    }

    private onRaceFinish(): void
    {
        this.resetCheckpoint({ x: this.game.level.courseEndX + 400, y: this.game.level.courseEndY });
    }

    public resetCheckpoint(point: {x: number, y: number}): void
    {
        this.checkPoint.x = point.x;
        this.checkPoint.y = point.y;
    }

    public setCheckpoint(point: {x: number, y: number}): boolean
    {
        if (this.game.vehicle.crashed) return false;
        this.checkPoint.x = point.x;
        this.checkPoint.y = point.y;

        return true;
    }

    public goToLastCheckpoint(): void
    {
        this.game.camera.setTarget(this.checkPoint);
        this.game.vehicle.respawn(this.checkPoint.x, this.checkPoint.y - 500, 0);
        this.game.soundSystem.playSfx('drop-landing');
        this.game.vehicle.motor.turnOff();
        this.game.player?.reset();
        this.waitingForLanding = true;
    }

    public physicsFixedUpdate(): void
    {
        if (this.waitingForLanding)
        {
            if (this.game.vehicle.chassis.physics.y >= this.checkPoint.y)
            {
                this.releaseVehicle();
            }
        }
    }

    private releaseVehicle(): void
    {
        this.waitingForLanding = false;
        this.game.vehicle.motor.turnOn();
        this.game.camera.setTarget(this.game.vehicle.chassis, true);
    }

    public update(): void
    {
        //
    }
}
